<owl-carousel-o [options]="customOptions">
  <ng-container *ngFor="let slide of slidesStore">
    <ng-template carouselSlide>
      <img [src]="slide" />
    </ng-template>
  </ng-container>
</owl-carousel-o>
